<template>
  <div>
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div class="vx-col w-full flex mb-4" id="account-manage-buttons">
      <vs-button
        v-if="!loginRole.includes('accountant')"
        icon-pack="feather"
        type="border"
        icon="icon-edit"
        class="mr-4"
        :to="{name: 'app-production-edit', params: { userId: $route.params.userId }}"
      >Edit</vs-button>

      <vs-button
        v-if="user_data.products.length > 0"
        icon-pack="feather"
        icon="icon-file"
        class="mr-4"
        @click="GenerateDocumentEN"
      >Production PDF
      </vs-button>
      <!--<vs-button icon-pack="feather" type="border" icon="icon-file-text" class="mr-4" @click='GenerateDocument'>Document</vs-button>-->
    </div>
    <div id="user-data" v-if="user_data">
      <div class="vx-row" id="page-user-view">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Operation" class="mb-base">
            <table>
              <!--<tr>
                <td class="font-semibold">Active?</td>
                <td><vs-chip v-if="user_data.isactive" color="primary">{{ user_data.isactive }}</vs-chip>
                <vs-chip v-else color="danger">{{ user_data.isactive }}</vs-chip></td>
              </tr>-->
              <tr>
                <td class="font-semibold">Internal ID</td>
                <td v-if="user_data.name">#{{ user_data.name }}</td>
                <td v-else="user_data.id">#{{ user_data.id }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Active</td>
                <td>
                  <vs-chip v-if="user_data.isactive" color="primary">{{ user_data.isactive }}</vs-chip>
                  <vs-chip v-else color="danger">{{ user_data.isactive }}</vs-chip>
                </td>
              </tr>
              <tr v-if="user_data.transport_tonaj">
                <td class="font-semibold">Weight (t)</td>
                <td>
                  {{ user_data.transport_tonaj }}
                </td>
              </tr>
              <tr v-if="user_data.sumal_aviz_nr">
                <td class="font-semibold">Aviz No</td>
                <td>
                  {{ user_data.sumal_aviz_nr }}
                </td>
              </tr>
              <tr v-if="user_data.truck_plate">
                <td class="font-semibold">License plate</td>
                <td>
                  {{ user_data.truck_plate }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Operation date</td>
                <td>{{ format_date(user_data.date,false) }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Create/Update</td>
                <td>{{ format_date(user_data.createdAt,true) }} / {{ format_date(user_data.updatedAt,true) }}</td>
              </tr>
            </table>
          </vx-card>
        </div>

      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card title="Product Moves" class="mb-base">
            <vs-alert
              v-if="m3difference <= 0.0000001"
              color="success"
              title="Success"
              active="true"
            >The difference between Stock IN and Stock OUT is equals to ZERO m3.</vs-alert>

            <vs-alert
              v-else
              color="danger"
              title="Danger"
              active="true"
            >The difference between Stock IN and Stock OUT is {{ Number(Math.abs(m3difference)).toFixed(4) }} m3.</vs-alert>
            <template>
              <div id="data-list-list-view" class="data-list-container">
                <vs-table ref="table" :data="user_data.products">
                  <template slot="thead">
                    <vs-th sort-key="category">Type</vs-th>
                    <vs-th sort-key="category">Category</vs-th>
                    <vs-th sort-key="Product">Product</vs-th>
                    <vs-th sort-key="username">Quantity</vs-th>
                    <vs-th sort-key="username">Unit of Measure</vs-th>
                    <vs-th sort-key="username">Volume Unit (m3)</vs-th>
                    <vs-th sort-key="username">Volume Total (m3)</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <tbody>
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td v-if="tr.operations_products.quantity >= 0">
                          <vs-chip color="green">
                            <p class="font-medium truncate">STOCK IN</p>
                          </vs-chip>
                        </vs-td>
                        <vs-td v-else>
                          <vs-chip color="red">
                            <p class="font-medium truncate">STOCK OUT</p>
                          </vs-chip>
                        </vs-td>
                        <vs-td>{{ tr.productcategory.name_en }}</vs-td>
                        <vs-td>{{ tr.name_en }}</vs-td>
                        <vs-td>{{ Number(tr.operations_products.quantity).toFixed(4) }}</vs-td>
                        <vs-td>{{ tr.uomsreference.name_en }}</vs-td>
                        <vs-td>{{ Number(tr.volume).toFixed(4) }}</vs-td>
                        <vs-td>{{ Number(tr.volume*tr.operations_products.quantity).toFixed(4) }}</vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
            </template>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { AmiriRegular } from "@/assets/fonts/Amiri-Regular-normal.js";
import axios from "@/axios.js";

export default {
  data() {
    return {
      user_data: null,
      user_not_found: false,
      m3difference: 0,
      productout: [],
      productin: [],
      sumIn:null,
      sumOut:null,
      loginRole: ''
    };
  },
  mounted() {
    // On récupère les rôles depuis localStorage dans le lifecycle hook
    const role = localStorage.getItem('login-roles');
    if (role) {
      this.loginRole = role.toLowerCase(); // Assigne la valeur convertie en minuscule
    }
  },
  computed: {

    getInOutDifference() {
      axios
        .get(
          "/operation-production/getinoutdifference/" +
            this.$route.params.userId
        )
        .then(response => {
          this.m3difference = Math.abs(response.data.volume);
        });
    },
    userAddress() {
      let str = "";
      for (const field in this.user_data.address) {
        str += `${field} `;
      }
      return str;
    }
  },
  methods: {
    getInSum() {
      axios
        .get(
          "/operation-production/getin/" +
            this.$route.params.userId
        )
        .then(response => {
          this.sumIn = Math.abs(response.data[0].round);
        });
    },
    getoutSum() {
      axios
        .get(
          "/operation-production/getout/" +
            this.$route.params.userId
        )
        .then(response => {
          this.sumOut = Math.abs(response.data[0].round);
        });
    },
    getProductOutPdf() {
      axios
        .get("/getproductlistoutpdf/" + this.$route.params.userId)
        .then(response => {
          this.productout = [...response.data];
        });
    },
    getProductInPdf() {
      axios
        .get("/getproductlistinpdf/" + this.$route.params.userId)
        .then(response => {
          this.productin = [...response.data];
        });
    },
    GenerateDocumentEN() {
      const doc = new jsPDF({
        /*filters: ["ASCIIHexEncode"],
        orientation: "portrait"*/
      });
      // SET FONT FROM ASSET ASCII
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");
      doc.setFontSize(10);
      let imgxylo = "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";

      // ADD IMAGE AND TITLE/DATE

      //doc.setFontType("bold");
      doc.addImage(imgxylo, "JPEG", 10, 5, 60, 22);
      doc.setFontSize(8);
      doc.text(155, 5, "Generated on " + this.format_date(Date(), true));
      doc.text(
        155,
        9,
        "Operation Date " + this.format_date(this.user_data.date, false)
      );

      //doc.setFontSize(9);
      /*doc.text(140, 20, 'System Create ' + this.format_date(this.user_data.createdAt,true));
      doc.text(140, 25, 'System Update ' + this.format_date(this.user_data.createdAt,true));*/
      doc.setFontSize(14);
      if (this.user_data.name) {
        doc.text(
          88,
          12,
          this.user_data.operationcategory.name_en + " #" + this.user_data.name
        );
      }
      else {
        doc.text(
          88,
          12,
          this.user_data.operationcategory.name_en + " #" + this.user_data.id
        );
      }

      doc.setFontSize(10);

      if (this.user_data.sumal_aviz_nr)
      doc.text(
        138,
        32,
        "Sumal 2.0 Identification"
      );

      doc.setFontSize(8);
      if (this.user_data.sumal_aviz_nr)
      doc.text(
        138,
        36,
        "APV No: " + this.productout[0].prod_en
      );
      if (this.user_data.sumal_aviz_nr)
      doc.text(
        138,
        39,
        "Aviz No: " + this.user_data.sumal_aviz_nr
      );
      // CONTENU

      doc.setFontSize(10);
      doc.text(10, 32, "XYLO Impact SRL");
      doc.setFontSize(8);
      doc.text(10, 36, "Strada Principala 115A, Teiu 337291 (Romania)");
      doc.text(10, 39, "VAT: RO33531190   " + "REG. COM.: J2022000979207");
      /*
      doc.text(10, 38, "Delivery: Sat Teiu, FN,");
      doc.text(10, 41, "337280, Comună Lăpugiu de Jos,");
      doc.text(10, 44, "Județul Hunedoara (Romania)");
*/ doc.setFontSize(
        8
      );
      // PRODUITS
      /*let totalAmountRow = {
        name_en: "Total",
        pricetotal: Math.abs(
          this.$store.state.operationList.eurdifference
        ).toFixed(2),
        volumetotal: Math.abs(
          this.$store.state.operationList.m3difference
        ).toFixed(4)
      };*/
      //this.productlistplustotal.push(totalAmountRow);
      doc.text(15, 58, "Product OUT : " + this.sumOut+" m3");
      var col = [
        { header: "Category", dataKey: "name_en" },
        { header: "Product", dataKey: "prod_en" },
        { header: "Quantity", dataKey: "quantity" },
        { header: "Unit of Measure", dataKey: "uom" },
        { header: "Unit Volume (m3)", dataKey: "unitvolume" },
        { header: "Volume (m3)", dataKey: "volumetotal" }
      ];
      doc.autoTable({
        margin: {
          top: 60
        },
        theme: "grid",
        styles: {
          fontSize: 7,
          volumetotal: { halign: "right" },
          quantity: { halign: "right" },
          unitprice: { halign: "right" },
          pricetotal: { halign: "right" }
          //pricetotalron: { halign: "right" }
        },
        columnStyles: {
          unitvolume: { halign: "right" },
          volumetotal: { halign: "right" },
          quantity: { halign: "right" },
          unitprice: { halign: "right" },
          pricetotal: { halign: "right" }
          //pricetotalron: { halign: "right" }
        },
        body: this.productout,
        columns: col
      });
      let start_in = 72.38; //98.94
      if (this.productout.length > 20)
      {
         start_in = 20
         doc.addPage();
      }
      else start_in = start_in + this.productout.length * 6.38;
      doc.text(15, start_in , "Product IN : " + this.sumIn+" m3");
      start_in = start_in+5
      var col = [
        { header: "Category", dataKey: "name_en" },
        { header: "Product", dataKey: "prod_en" },
        { header: "Quantity", dataKey: "quantity" },
        { header: "Unit of Measure", dataKey: "uom" },
        { header: "Unit Volume (m3)", dataKey: "unitvolume" },
        { header: "Volume (m3)", dataKey: "volumetotal" }
      ];
      doc.autoTable({
        margin: {
          top: start_in
        },
        theme: "grid",
        styles: {
          fontSize: 7,
          volumetotal: { halign: "right" },
          quantity: { halign: "right" },
          unitprice: { halign: "right" },
          pricetotal: { halign: "right" }
          //pricetotalron: { halign: "right" }
        },
        columnStyles: {
          unitvolume: { halign: "right" },
          volumetotal: { halign: "right" },
          quantity: { halign: "right" },
          unitprice: { halign: "right" },
          pricetotal: { halign: "right" }
          //pricetotalron: { halign: "right" }
        },
        body: this.productin,
        columns: col
      });
      doc.setFontSize(10);
      doc.save(
          moment(this.user_data.date).format("YYYYMMDD") +
          "_" +
          this.user_data.operationcategory.name_en +
          "_" +
          this.user_data.id +
          ".pdf"
      );
    },
    format_date(value, withhour) {
      if (value) {
        if (withhour)
          return moment(String(value)).format("DD MMM YYYY HH:mm:ss");
        else return moment(String(value)).format("DD MMM YYYY");
      }
    },
    moment: function() {
      return moment();
    },
    ViewCompany() {
      window.location.replace("/person/" + this.user_data.Company.id);
    },
    getActiveColors(status) {
      if (status === true) return "primary";
      if (status === false) return "danger";
      return "warning";
    }
  },
  created() {
    // Register Module UserManagement Module
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }

    const userId = this.$route.params.userId;
    this.$store
      .dispatch("operationList/fetchOperation", userId)
      .then(res => {
        this.user_data = res.data;
        if (this.user_data.operationcategory.id === 3) {
          // STAY
          this.getProductInPdf();
          this.getProductOutPdf();
          this.getoutSum();
          this.getInSum();
          this.getInOutDifference();
        } else {
          this.$router.push({ path: "/pages/error-404" });
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.user_not_found = true;
          return;
        }
        console.error(err);
      });
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
/*
.vs-chip-success {
  background: rgba(var(--vs-success), 0.15);
  color: rgba(var(--vs-success), 1) !important;
  font-weight: 500;
}
.vs-chip-warning {
  background: rgba(var(--vs-warning), 0.15);
  color: rgba(var(--vs-warning), 1) !important;
  font-weight: 500;
}
.vs-chip-danger {
  background: rgba(var(--vs-danger), 0.15);
  color: rgba(var(--vs-danger), 1) !important;
  font-weight: 500;
}*/
</style>
